import { createConfigLoader } from "@/config";

// Interface for contacts configuration
export interface IContactsConfig {
  phone: string;
  email: string;
  whatsapp?: string;
  telegram?: string;
  telegramBot?: string;
  viber?: string;
  wechat?: string; // Optional field for WeChat
  botim?: string; // Optional field for Botim
  address: {
    en: string;
    el: string;
    ru: string;
    fr?: string;
    ar?: string;
    es?: string;
  };
  location: {
    city: string;
    country: string;
    lat?: number;
    lng?: number;
  };
}

// Default contacts configuration
const defaultContactsConfig: IContactsConfig = {
  phone: "+00000000000",
  email: "info@avezor.test",
  whatsapp: "#",
  telegram: "#",
  viber: "#",
  // wechat: "#",
  // botim: "#",
  address: {
    en: "Unknown 99, Unknown 999 99",
    el: "Άγνωστο 99, Άγνωστη 999 99",
    ru: "Неизвестно 99, Неизвестно 999 99",
  },
  location: {
    city: "Unknown",
    country: "Unknown",
  },
};

const defaultOffices = [defaultContactsConfig];

// Load configuration with country-specific overrides
export const contactsConfig = createConfigLoader(
  defaultContactsConfig,
  "contacts",
);

export const officesConfig = createConfigLoader<IContactsConfig[]>(
  defaultOffices,
  "offices",
);
